
import SingleStreetLight from '../../../../features/planBT/components/Streetlight/SingleStreetLight'

import HeaderWidget from '../../../../common/components/molecule/HeaderWidget/HeaderWidget'
import CreateUpdateStreetLightPresenter from '../../../../features/planBT/components/Streetlight/CreateUpdateStreetLight/CreateUpdateStreetLightPresenter'
import { useMicroNavigator } from '../../../../common/components/organisme/MicroNavigator/MicroNavigatorContext'

export default function UpdateStreetLightPage() {
  const {navigate} = useMicroNavigator()
  return (
    <div style={{color: 'white'}}>
        <HeaderWidget handleBackBtn={() => navigate('list')} variant={'dark'}>
            Modifier <SingleStreetLight.Title/>
        </HeaderWidget>
        <CreateUpdateStreetLightPresenter isUpdate={true}/>
    </div>
  )
}
